export const hasInvoice = (order: GQL.IOrder) => {
    return Array.isArray(order.invoices) && order.invoices.filter(i => i.type === 'invoice').length > 0;
};



// WEBPACK FOOTER //
// ./src/helpers/orders/hasInvoice.ts